module.exports = __webpack_public_path__ + "static/media/kick.fd268628.mp3";